import React from 'react';
import './RegistrationFailPage.scss';
import { RegistrationFailViewProps } from './registrationfailpage.props';

const RegistrationFailPageView: React.FC<RegistrationFailViewProps> = ({
  loading, error, retryLink, emailSent, onNavigateHome,
}) => {
  return (
    <div className="registration-fail-page">
      <div className="container">
        <div className="fail-card">
          <div className="fail-icon">✕</div>
          <h1>Плаќањето не успеа</h1>
          <p>
            За жал, вашето плаќање не беше успешно обработено.
            Вашата регистрација е зачувана, но не е потврдена.
          </p>

          {loading && (
            <p className="retry-loading">Генерирање на линк за повторен обид...</p>
          )}

          {retryLink && (
            <div className="retry-section">
              <div className="retry-icon">🔄</div>
              <h3>Обидете се повторно</h3>
              <p>Кликнете на копчето подолу за повторно да се обидете. Вашите податоци ќе бидат автоматски пополнети.</p>
              <a href={retryLink} className="btn primary retry-btn">
                Обиди се повторно
              </a>
              <div className="retry-info">
                <span>⏱ Линкот е валиден 24 часа • Максимум 10 обиди</span>
              </div>
            </div>
          )}

          {emailSent && (
            <div className="email-sent-notice">
              <span>✉️</span>
              <p>Испративме е-пошта со линк за повторен обид на вашата адреса.</p>
            </div>
          )}

          {error && (
            <div className="retry-error">
              <p>{error}</p>
            </div>
          )}

          <div className="contact-info">
            <span className="contact-label">Контакт е-пошта</span>
            <a href="mailto:info@drimrun.mk" className="contact-email">info@drimrun.mk</a>
          </div>

          <div className="action-buttons">
            {!retryLink && (
              <button onClick={onNavigateHome} className="btn primary">
                Назад кон почетна
              </button>
            )}
            <button onClick={onNavigateHome} className="btn secondary">
              Назад кон почетна
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationFailPageView;
